
const conseguirDatoAValidar = (paso, objeto) => {
    switch(paso) {
        case 1:
            return objeto.nombre;
        case 2:
            return objeto.telefono;
        case 3:
            return objeto.correo;
        case 4:
            return objeto.ubicacion;
        case 5:
            return objeto.titular;
        case 6:
            return objeto.marca;
        case 7:
            return objeto.modelo;
        case 8:
            return objeto.anio;
        case 9:
            return objeto.version;
        case 10:
            return objeto.km;
        case 11:
            return objeto.patente;
        case 12:
            return objeto.estado;
        default:
            return null;
    }    
};

const conseguirDatoCompraAValidar = (paso, objeto) => {
    switch(paso) {
        case 1:
            return objeto.nombre;
        case 2:
            return objeto.telefono;
        case 3:
            return objeto.correo;
        case 4:
            return objeto.ubicacion;
        case 5:
            return objeto.descripcionAuto;
        case 6:
            return objeto.presupuesto;
        default:
            return null;
    }    
};

const validateFormContent = (tipoValidacion, valor, settearError) => {
    settearError();
    switch (tipoValidacion) {
        case 1:
            // Validación para el texto
            const regex = /^[a-zA-Z0-9 ]{1,50}$/;
            if (!valor) {
                settearError('Este campo es obligatorio, por favor rellenarlo.');
                return false;
            }
            if (!regex.test(valor)) {
                settearError('El campo solo puede contener letras, números y espacios, con un máximo de 50 caracteres.');
                return false;
            }    
            break;
        case 2:
            // Validación para el teléfono
            const telefonoRegex = /^[0-9]{8,16}$/; // Ajusta la expresión regular según tu formato
            if (!telefonoRegex.test(valor)) {
                settearError('Ingrese un número de teléfono válido.');
                return false;
            }
            break;
        case 3:
            // Validación para el teléfono
            const emailRegex = /^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,50}$/; 
            if (!emailRegex.test(valor)) {
                settearError('Ingresa una dirección correo electrónico válida.');
                return false;
            }
            break;
        case 4:
                // Validación para el teléfono
                if (!valor) {
                    settearError('Por favor, seleccione una opción*');
                    console.log("Error")
                    return false;
                }
                break;
        case 5:
                // Validación para el teléfono
                const anioRegex = /^[0-9]{4,4}$/; // Ajusta la expresión regular según tu formato
                if (!anioRegex.test(valor)) {
                    settearError('Ingrese un año válido.');
                    return false;
                }
                break;
        case 6:
                // Validación para el teléfono
                const kmRegex = /^[0-9]{1,6}$/; // Ajusta la expresión regular según tu formato
                if (!kmRegex.test(valor)) {
                    settearError('Ingrese una cantidad de km válida.');
                    return false;
                }
                break;
        case 7:
                // Validación para el teléfono
                const patenteRegex = /^[a-zA-Z]{2}\d{3}[a-zA-Z]{2}$|^[a-zA-Z]{3}\d{3}$/; // Ajusta la expresión regular según tu formato
                if (!patenteRegex.test(valor)) {
                    settearError('Ingrese una patente válida.');
                    return false;
                }
                break;
        case 8:
            // Validación para la descripción
            const descRegex = /^(?!.*(--|;|\/\*|\*\/|xp_)).{1,350}$/; // Ajusta la expresión regular según tu formato
            if (!descRegex.test(valor)) {
                settearError('Recuerde que no se pueden usar caracteres especiales o excederse del límite de 350 caracteres.');
                return false;
            }
            break;
        case 9:
            // Validación para el presupuesto
            const presupuestoRegex = /^[0-9]{1,8}$/; // Ajusta la expresión regular según tu formato
            if (!presupuestoRegex.test(valor)) {
                settearError('Ingrese un presupuesto válido.');
                return false;
            }
            break;
        // Agrega más casos según los pasos restantes
        default:
            break;
    }
    return true;
};


export {
    conseguirDatoAValidar,
    validateFormContent,
    conseguirDatoCompraAValidar
}